export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13327.420bd1a9.jpg";